import angular from 'angular';

import { NewsListerService } from './news-lister.service';

const MODULE_NAME = 'NewsLister';

export default angular.module(MODULE_NAME, []).service('NewsListerService', NewsListerService).name;


